import url from "../constants/urlList";

// Live polling-session API (Q7-T1). DARK: the server 404s every route until
// qlearn.live-session.enabled is on in the target environment, so these calls
// simply fail (handled by callers) while the feature is dark. Director calls ride
// the Bearer token the patched global fetch attaches; public calls are anonymous.

const base = url.liveSession;

async function asJson(res) {
    if (res.status === 304) {
        return { unchanged: true };
    }
    const text = await res.text();
    const body = text ? JSON.parse(text) : {};
    if (!res.ok) {
        const err = new Error(body && body.message ? body.message : `HTTP ${res.status}`);
        err.status = res.status;
        throw err;
    }
    return body;
}

function postJson(path, payload) {
    return fetch(`${base}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload || {}),
    }).then(asJson);
}

function post(path) {
    return fetch(`${base}${path}`, { method: "POST" }).then(asJson);
}

function get(path) {
    return fetch(`${base}${path}`).then(asJson);
}

// ---- Director (JWT) ----
export const createLiveSession = (body) => postJson("", body);
export const advanceLiveSession = (id) => post(`/${encodeURIComponent(id)}/advance`);
export const revealLiveSession = (id) => post(`/${encodeURIComponent(id)}/reveal`);
export const endLiveSession = (id) => post(`/${encodeURIComponent(id)}/end`);
export const getPresenterState = (id) => get(`/${encodeURIComponent(id)}`);

// ---- Public (anonymous) ----
export const joinLiveSession = (shortCode) => postJson("/public/join", { shortCode });
export const getPublicState = (shortCode, version) =>
    get(`/public/${encodeURIComponent(shortCode)}/state${version != null ? `?version=${version}` : ""}`);
export const answerLiveSession = (payload) => postJson("/public/answer", payload);
